export default "<div>\r\n  <adpkd-header></adpkd-header>\r\n  <adpkd-side-bar></adpkd-side-bar>\r\n  <adpkd-footer></adpkd-footer>\r\n</div>\r\n";